import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { searchMedications } from '@api/medications';
import { IMedicationsSearchResult, ISearchMedicationsProps } from '@interfaces/medications';

import { buildSearchMedicationsPayload } from './utils';

export const handleGetMedicationSearch = createAsyncThunk<
  AxiosResponse<IMedicationsSearchResult>,
  ISearchMedicationsProps
>('searchMedications', props => searchMedications(buildSearchMedicationsPayload(props)));
